import AutomationCommon from "../common";
import AutomationBlockTypes from "../../AutomationBlockTypes";
const vt = AutomationCommon.vt;
const contexts = AutomationCommon.contexts;
const ga = AutomationCommon.ga;

function generateAttributesFromExampleResult(prefix, exampleResult) {
    if (Array.isArray(exampleResult)) {
        var firstValid = exampleResult.find(function (item) { return item !== null && typeof item === "object"; });
        var subAttrs = firstValid ? generateAttributesFromExampleResult(`${prefix}.$..`, firstValid) : undefined;
        // Her array seviyesinde * wildcard ekle, subAttributes: undefined
        return [
            ga(contexts.BLOCK, `${prefix}.$..*`, "*", vt.ARRAY_OBJECT, undefined, undefined),
            ...(subAttrs || [])
        ];
    }
    if (exampleResult && typeof exampleResult === "object") {
        var attrs = Object.keys(exampleResult).map(function (key) {
            var value = exampleResult[key];
            var valueType = vt.STRING;
            if (typeof value === "number") valueType = vt.NUMBER;
            else if (typeof value === "boolean") valueType = vt.BOOLEAN;
            else if (Array.isArray(value)) valueType = vt.ARRAY_OBJECT;
            else if (typeof value === "object" && value !== null) valueType = vt.OBJECT;
            var subAttrs = (typeof value === "object" && value !== null)
                ? generateAttributesFromExampleResult(`${prefix}.${key}`, value)
                : undefined;
            return ga(contexts.BLOCK, `${prefix}.${key}`, key, valueType, undefined, subAttrs);
        });
        // Her obje seviyesinde * wildcard ekle, subAttributes: undefined
        return [
            ga(contexts.BLOCK, `${prefix}.$..*`, "*", vt.OBJECT, undefined, undefined),
            ...attrs
        ];
    }
    return [];
}

class RunJavaScriptAttributeFactory {
    constructor(parent) {
        this.parent = parent;
    }

    generate(prefix, block) {
        if (block.type !== AutomationBlockTypes.RUN_JAVASCRIPT) {
            return [];
        }
        const exampleResult = block.payload && block.payload.exampleResult;
        if (!exampleResult) return [];
        // root array ise isRoot=true gönder
        return generateAttributesFromExampleResult(prefix, exampleResult, Array.isArray(exampleResult));
    }
}

export default RunJavaScriptAttributeFactory; 